import { Component, inject, ViewEncapsulation } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import {
  SystemBannerService,
  SystemBannerSeverity,
} from "@app/common/services/system-banner.service";

@Component({
  selector: "tp-system-banner",
  standalone: true,
  imports: [MatIconModule, MatButtonModule],
  templateUrl: "./system-banner.component.html",
  styleUrls: ["./system-banner.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class SystemBannerComponent {
  readonly svc = inject(SystemBannerService);

  iconFor(severity: SystemBannerSeverity): string {
    switch (severity) {
      case "error":
        return "error_outline";
      case "warning":
        return "warning_amber";
      case "success":
        return "check_circle";
      default:
        return "info";
    }
  }
}
